import { render } from "./AvariaResumo.vue?vue&type=template&id=454e772f"
import script from "./AvariaResumo.vue?vue&type=script&lang=js"
export * from "./AvariaResumo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__